const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF;

export const StudioFileManagerQueryURL = {
    GetShootingTypes: Backofficebff + '/v1/ShootingType/get-shooting-type',
};
